<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'analytics.range.dialog.title' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="onCancel()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <app-range-calendar
      [label]="'analytics.range.label' | translate"
      [dateRangeForm]="dateRangeForm"
    />
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="onCancel()">
      {{ 'cancel' | translate }}
    </button>
    <button mat-raised-button color="primary" type="button" (click)="onApply()">
      {{ 'apply' | translate }}
    </button>
  </footer>
</div>
